/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { S_Btn_Search, S_Select, S_Title } from '~/components/SearchItem';
import Actions_Wind from '~/Actions_Wind';
import excel from '~/skills/excel';
import { T_TableRow, T_TitleCell } from '~/components/TableItem';
import PageTitle from '~/components/PageTitle';
import ExportButton from '~/components/Button/ExportButton';
import SearchBar from '~/components/SearchBar';
import Map from './Map';
const ary = [
  {
    name: '基樁',
    detail: [
      { name: '製造' },
      { name: '運輸' },
      { name: '安裝' },
    ],
  },
  {
    name: '水下基礎(套筒)',
    detail: [
      { name: '製造' },
      { name: '運輸' },
      { name: '安裝' },
    ],
  },
  // {
  //   name: '水下基礎(單樁)',
  //   detail: [
  //     { name: '製造' },
  //     { name: '運輸' },
  //     { name: '安裝' },
  //   ],
  // },
  {
    name: '機艙',
    detail: [
      { name: '製造' },
      { name: '運輸' },
    ],
  },
  {
    name: '葉片',
    detail: [
      { name: '製造' },
      { name: '運輸' },
    ],
  },
  {
    name: '塔架',
    detail: [
      { name: '製造' },
      { name: '運輸' },
    ],
  },
  {
    name: '風力機',
    detail: [
      { name: '安裝' },
      { name: '併聯' },
    ],
  },
];

const RenderTableTitle = () => (
  <TableHead>
    <TableRow style={{ height: 48 }}>
      <T_TitleCell rowSpan={2} style={{ fontSize: 20 }} color='#247691' text='項目' />
      {ary.map((o, i) => (
        <T_TitleCell
          key={i}
          style={{
            border: 'solid #DDDDDD',
            borderWidth: `0px ${(i !== (ary.length - 1)) ? 1 : 0}px 1px 1px`,
          }}
          text={o.name}
          colSpan={o.detail.length || 1}
        />
      ))}
    </TableRow>
    <TableRow style={{ height: 48 }}>
      {ary.map((o, i) => o.detail.map((o2, i2) => (
        <T_TitleCell
          key={`${i}-${i2}`}
          style={{
            border: 'solid #DDDDDD',
            borderWidth: `0px ${((i2 === (o.detail.length - 1)) && (i !== (ary.length - 1))) ? 1 : 0}px 1px ${(i2 === 0) ? 1 : 0}px`,
          }}
          text={o2.name}
          color='#247691'
        />
      )))}
    </TableRow>
  </TableHead>
);

const RenderTableBody = () => {
  const list = useSelector(state => state.data.FanProjectProcess || []);
  const cellStyle = { fontSize: 14 };

  return (
    <TableBody>
      {list.map((o, i) => (
        <T_TableRow key={i}>
          <TableCell align='center' style={{ color: '#247691', ...cellStyle }}>{o.fan_point}</TableCell>
          <TableCell align='center' style={{ backgroundColor: '#EBF3F5', ...cellStyle }}>{o.foundation_made_stage === '3' ? o.foundation_actual_made_date : o.foundation_plan_made_date}</TableCell>
          <TableCell align='center' style={{ backgroundColor: '#EBF3F5', ...cellStyle }}>{o.foundation_tran_taiwan === '1' ? (o.foundation_is_tran_taiwan === '1' ? o.foundation_actual_tw_date : o.foundation_tw_date) : '-'}</TableCell>
          <TableCell align='center' style={{ backgroundColor: '#EBF3F5', ...cellStyle }}>{o.foundation_progress === '3' ? o.foundation_actual_install_date : o.foundation_plan_install_date}</TableCell>
          <TableCell align='center' style={cellStyle}>{o.tp_made_stage === '3' ? o.tp_actual_made_date : o.tp_plan_made_date}</TableCell>
          <TableCell align='center' style={cellStyle}>{o.tp_tran_taiwan === '1' ? (o.tp_is_tran_taiwan === '1' ? o.tp_actual_tw_date : o.tp_tw_date) : '-'}</TableCell>
          <TableCell align='center' style={cellStyle}>{o.tp_progress === '3' ? o.tp_actual_install_date : o.tp_plan_install_end_date}</TableCell>
          <TableCell align='center' style={{ backgroundColor: '#EBF3F5', ...cellStyle }}>{o.cabin_made_stage === '3' ? o.cabin_actual_made_date : o.cabin_plan_made_date}</TableCell>
          <TableCell align='center' style={{ backgroundColor: '#EBF3F5', ...cellStyle }}>{o.cabin_tran_taiwan === '1' ? (o.cabin_is_tran_taiwan === '1' ? o.cabin_actual_tw_date : o.cabin_tw_date) : '-'}</TableCell>
          <TableCell align='center' style={cellStyle}>{o.tower_made_stage === '3' ? o.tower_actual_made_date : o.tower_plan_made_date}</TableCell>
          <TableCell align='center' style={cellStyle}>{o.tower_tran_taiwan === '1' ? (o.tower_is_tran_taiwan === '1' ? o.tower_actual_tw_date : o.tower_tw_date) : '-'}</TableCell>
          <TableCell align='center' style={{ backgroundColor: '#EBF3F5', ...cellStyle }}>{o.blade_made_stage === '3' ? o.blade_actual_made_date : o.blade_plan_made_date}</TableCell>
          <TableCell align='center' style={{ backgroundColor: '#EBF3F5', ...cellStyle }}>{o.blade_tran_taiwan === '1' ? (o.blade_is_tran_taiwan === '1' ? o.blade_actual_tw_date : o.blade_tw_date) : '-'}</TableCell>
          <TableCell align='center' style={cellStyle}>{o.install_stage < '3' ? o.install_plan_date : o.install_actual_date }</TableCell>
          <TableCell align='center' style={cellStyle}>{o.install_stage <= '3' ? o.merge_plan_date : (o.install_stage === '4' ? o.merge_actual_date : '-')}</TableCell>
        </T_TableRow>
      ))}
    </TableBody>
  );
};

const RenderTable = () => {
  const list = useSelector(state => state.data.FanProjectProcess || []);
  const haveData = list.length > 0;
  return (
    <TableContainer>
      <Table style={{ backgroundColor: 'white', borderRadius: 8 }}>
        <RenderTableTitle />
        {haveData && <RenderTableBody />}
      </Table>
    </TableContainer>
  );
};

const App = props => {
  const [data, setData] = useState({ windId: '' });
  const { windId } = data;
  const dispatch = useDispatch();
  const SwitchProjectList = useSelector(state => state.data.SwitchProjectList || []);
  const list = useSelector(state => state.data.FanProjectProcess || []);
  const FanProjectProcessMap = useSelector(state => state.data.FanProjectProcessMap || []);
  const haveData = list.length > 0;
  const onClickSearch = () => {
    Actions_Wind.Gis.getFanProjectProcess(dispatch, { id: windId });
    Actions_Wind.Gis.getFanProjectProcessMap(dispatch, { id: windId });
  };
  const onExport = () => {
    if (!haveData)alert('無匯出資料');
    else {
      let name = '';
      SwitchProjectList.forEach(o => {
        if (o.value === windId)name = o.name;
      });

      const header = ['項目'];
      ary.forEach(o => {
        header.push(o.name);
        o.detail.forEach((_, i2) => { if (i2)header.push(''); });
      });

      const ary1 = [''];
      ary.forEach(o => o.detail.forEach(o2 => ary1.push(o2.name)));

      excel.outputAryAry({
        header,
        data: [
          ary1,
          ...list.map(o => [
            o.fan_point,
            o.foundation_made_stage === '3' ? o.foundation_actual_made_date : o.foundation_plan_made_date,
            o.foundation_tran_taiwan === '1' ? (o.foundation_is_tran_taiwan === '1' ? o.foundation_actual_tw_date : o.foundation_tw_date) : '-',
            o.foundation_progress === '3' ? o.foundation_actual_install_date : o.foundation_plan_install_date,
            o.tp_made_stage === '3' ? o.tp_actual_made_date : o.tp_plan_made_date,
            o.tp_tran_taiwan === '1' ? (o.tp_is_tran_taiwan === '1' ? o.tp_actual_tw_date : o.tp_tw_date) : '-',
            o.tp_progress === '3' ? o.tp_actual_install_date : o.tp_plan_install_end_date,
            o.cabin_made_stage === '3' ? o.cabin_actual_made_date : o.cabin_plan_made_date,
            o.cabin_tran_taiwan === '1' ? (o.cabin_is_tran_taiwan === '1' ? o.cabin_actual_tw_date : o.cabin_tw_date) : '-',
            o.tower_made_stage === '3' ? o.tower_actual_made_date : o.tower_plan_made_date,
            o.tower_tran_taiwan === '1' ? (o.tower_is_tran_taiwan === '1' ? o.tower_actual_tw_date : o.tower_tw_date) : '-',
            o.blade_made_stage === '3' ? o.blade_actual_made_date : o.blade_plan_made_date,
            o.blade_tran_taiwan === '1' ? (o.blade_is_tran_taiwan === '1' ? o.blade_actual_tw_date : o.blade_tw_date) : '-',
            o.install_stage < '3' ? o.install_plan_date : (o.install_stag === '3' ? o.install_actual_date : '-'),
            o.install_stage < '3' ? o.merge_plan_date : (o.install_stag === '4' ? o.merge_actual_date : '-'),
          ]),
        ],
        fileName: `風機點位工進表${name}`,
      });
    }
  };
  useEffect(() => () => {
    Actions_Wind.clearKey(dispatch, { key: 'FanProjectProcess' });
    Actions_Wind.clearKey(dispatch, { key: 'FanProjectProcessMap' });
  }, []);

  return (
    <div style={{
      position: 'absolute',
      left: 13,
      right: 0,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      overflow: 'auto',
    }}
    >
      <PageTitle text='風機點位工進表' />

      <div style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
        <ExportButton style={{ marginRight: 28 }} onClick={onExport} />
      </div>
      <SearchBar style={{ marginTop: 16, marginBottom: 25 }} text='點位工進表' defaultOpen>
        <div style={{ display: 'flex' }}>
          <div>
            <S_Title text='風場' />
            <S_Select list={SwitchProjectList} value={windId} onChange={t => setData({ ...data, windId: t })} />
          </div>
          <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column-reverse' }}>
            <S_Btn_Search onClick={onClickSearch} />
          </div>
        </div>
        <div style={{ marginLeft: 52, marginRight: 52, marginTop: 20, marginBottom: 20 }}>
          <div style={{ borderRadius: 8, boxShadow: '0px 4px 13px rgba(24, 98, 121, 0.4)' }}>
            <RenderTable />
            {/* {haveData && this.renderTableBar()} */}
          </div>
          {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        </div>
      </SearchBar>
      {!!FanProjectProcessMap.length && <Map />}
    </div>
  );
};

export default App;
